import { Link } from "react-router-dom";

const HANGERS = [[10, 25.1], [18, 20.5], [26, 14.1], [40.5, 11.25], [47, 15], [53.5, 17.25], [60, 18], [66.5, 17.25], [73, 15], [79.5, 11.25], [94, 14.1], [102, 20.5], [110, 25.1]];

export const BridgeMark = ({ color = "#650D23", className = "h-7 w-auto" }) => (
  <svg viewBox="0 0 120 38" fill="none" className={className} aria-hidden="true">
    <path d="M1 28 Q18 25 34 6 Q60 31 86 6 Q102 25 119 28" stroke={color} strokeWidth="1.4" />
    {HANGERS.map(([x, y]) => <path key={x} d={`M${x} ${y} V28`} stroke={color} strokeWidth="0.7" />)}
    <path d="M1 28 H119" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
    <path d="M32.6 4 H35.4 L36 34 H32 Z M84.6 4 H87.4 L88 34 H84 Z" fill={color} />
    <path d="M24 34.6 H44 M76 34.6 H96" stroke={color} strokeWidth="0.8" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light = false, testid = "site-logo", tagline = false }) => {
  const color = light ? "#FFFDFB" : "#650D23";
  return (
    <Link to="/" data-testid={testid} className="group inline-flex flex-col items-center gap-1" aria-label="STRUKTIV — Accueil">
      <BridgeMark color={color} className="h-8 w-auto transition-transform duration-300 group-hover:-translate-y-0.5" />
      <span className="font-sans text-[1.05rem] font-medium leading-none tracking-[0.42em] pl-[0.42em]" style={{ color }}>STRUKTIV</span>
      {tagline && <span className="mt-1 text-[0.55rem] tracking-[0.25em]" style={{ color }}>PROTECTION • PATRIMOINE • STRATÉGIE</span>}
    </Link>
  );
};
